import script from "./AppVideoEmbed.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVideoEmbed.vue?vue&type=script&setup=true&lang=js"

import "./AppVideoEmbed.vue?vue&type=style&index=0&id=425b9e95&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425b9e95"]])

export default __exports__